import type { TreeItem } from '../components/tree/treeMapper'
import { StorageNodeTypeEnum } from '@d/sdk'
import { flatTreeItems, selected } from '../components/tree/treeMapper'

const treeRefresh = ref(0)
const extra = ref<string[]>([])

interface TreeView {
  selectedElement: ComputedRef<TreeItem>
  selectedElementPath: ComputedRef<string>
  selectedElementPathArr: ComputedRef<string[]>
  parentElement: ComputedRef<TreeItem | undefined>
  closestDirectory: ComputedRef<TreeItem | undefined>
  getByPath: (path: string) => TreeItem | undefined
  refresh: (extra?: string[]) => void
  internal: {
    treeRefresh: Ref<number>
    extra: Ref<string[]>
  }
  setSelected: (path: string) => void
}

const selectedElement = computed(() => {
  return flatTreeItems.get(selected.value[selected.value.length - 1])!
})

const parentElement = computed(() => {
  const parentPath = selected.value[selected.value.length - 1]
    .split('/')
    .slice(0, -1)
    .join('/')
  return flatTreeItems.get(parentPath)
})

export function useTreeView(): TreeView {
  return {
    selectedElement,
    selectedElementPath: computed(
      () => selected.value[selected.value.length - 1],
    ),
    selectedElementPathArr: computed(
      () => selected.value[selected.value.length - 1]?.split('/'),
    ),
    parentElement,
    closestDirectory: computed(() => {
      const current = selectedElement.value
      if (current.type !== StorageNodeTypeEnum.File) {
        return current
      }
      return parentElement.value
    }),
    getByPath: (path: string) => {
      return flatTreeItems.get(path)
    },
    refresh: (xtra?: string[]) => {
      treeRefresh.value++
      extra.value = xtra ?? []
    },
    internal: {
      treeRefresh,
      extra,
    },
    setSelected: (path: string) => {
      selected.value = [path]
    },
  }
}
